import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { MACHINE_DATA, SIGNALS_FUNCTION } from 'src/app/core/config/config.constants';
import { environment } from 'src/environments/environment';
import { SignalCatalog } from '../models/widget-models';

@Injectable({
  providedIn: 'root'
})
export class MachineDataService {

  private baseUrl: string = environment.baseTsOhwUrl;
  
  constructor(private _httpClient: HttpClient) {}

  getMachineData(machines: string[]): Observable<any> {
    const apiCommand = {
      uidVehicles: machines
    };
    return this._httpClient.post(`${this.baseUrl}${MACHINE_DATA}`, apiCommand);
  }

  extractExpectedProperties(expectedSignals: SignalCatalog[], data: any[]) {
    const expectedNames = expectedSignals.map(signal => signal.name);
    const filteredData = Object.keys(data)
      .filter(key => expectedNames.includes(key))
      .reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, {});
    
    return filteredData;
  }

}